webpackJsonp([193786031782092],{

/***/ 1357:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---ignite-session-21-feb-2026-a0e39f21c11f6a62c5ab.js